import StatusCard from "../../components/Form.Status/Formstatus";
import { useState } from "react";
import {
  FaqBadge,
  FaqHeader,
  FaqTitle,
  NavLink,
  NavLinksContainer,
} from "../FAQ/FAQ.styled";
import pen from "../../assets/Forms.png";
import {
  FormCard,
  FormCardsContainer,
  FormInput,
  FormsContainer,
  FormSection,
  FormSelect,
  TrackButton,
  TrackInput,
  TrackSection,
} from "./Forms.styled";
import pdf from "../../assets/PdfIcon.svg";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import General from "../../stores/GeneralStore";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";

const Forms = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(1);
  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };
  const handleToggle = () => {
    setOpen(!open);

    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };
  const handleChange = (e: any) => {
    setValue(e.target.value);
  };

  return (
    <>
      <FaqHeader style={{ background: `url(${pen})` }}>
        <NavLinksContainer>
          <NavLink to="/">
            {General?.codeLabels["cm_home"]?.label !== undefined
              ? General?.codeLabels["cm_home"]?.label
              : " Home"}
          </NavLink>
          &nbsp;/&nbsp;
          <NavLink to="/">Our Services</NavLink>&nbsp;/&nbsp;
          <NavLink to="/">
            {General?.codeLabels["cm_forms"]?.label !== undefined
              ? General?.codeLabels["cm_forms"]?.label
              : "Forms"}
          </NavLink>
        </NavLinksContainer>
        <FaqTitle>
          {General?.codeLabels["cm_forms"]?.label !== undefined
            ? General?.codeLabels["cm_forms"]?.label
            : "Forms"}
        </FaqTitle>
        <FaqBadge style={{ width: "80%", left: "10%" }}>
          We have made it easy for you to have access to a number of forms
          needed for your Ajman Sewerage account.
        </FaqBadge>
      </FaqHeader>
      <FormsContainer>
        <FormSection>
          <h2>Download Forms</h2>
          <span>
            Save time by downloading the relevant form, fill it in at home and
            simply submit it at your nearest customer services centre, it is
            that easy.
          </span>
          <FormCardsContainer>
            <FormCard>
              <p>
                <img src={pdf} alt="pdf" />
                <span style={{ fontSize: ".6rem" }}>2MBS</span>
              </p>
              <p style={{ color: "#101e8e" }}>
                <span>Tenant Registration Form</span>
                <VerticalAlignBottomIcon />
              </p>
            </FormCard>
            <FormCard>
              <p>
                <img src={pdf} alt="pdf" />
                <span style={{ fontSize: ".6rem" }}>1.2MBS</span>
              </p>
              <p style={{ color: "#101e8e" }}>
                <span>Registration Form - Multiple Properties</span>
                <VerticalAlignBottomIcon />
              </p>
            </FormCard>
            <FormCard>
              <p>
                <img src={pdf} alt="pdf" />
                <span style={{ fontSize: ".6rem" }}>2MBS</span>
              </p>
              <p style={{ color: "#101e8e" }}>
                <span>Service Termination Form</span>
                <VerticalAlignBottomIcon />
              </p>
            </FormCard>
            <FormCard>
              <p>
                <img src={pdf} alt="pdf" />
                <span style={{ fontSize: ".6rem" }}>2MBS</span>
              </p>
              <p style={{ color: "#101e8e" }}>
                <span>Deposit Refund/Transfer Form</span>
                <VerticalAlignBottomIcon />
              </p>
            </FormCard>
          </FormCardsContainer>
        </FormSection>
        <FormSection>
          <h2>Track Your Form</h2>
          <TrackSection>
            <div>
              <p>Form Reference Number</p>
              <form style={{ flexDirection: "row" }}>
                <TrackInput type="text" required />
                <TrackButton type="submit" onClick={handleToggle} />
              </form>
            </div>
          </TrackSection>
        </FormSection>
        <FormSection>
          <h2>Submit Your Form</h2>
          <div style={{ background: "#eee", width: "100%", padding: "2rem" }}>
            <form>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  margin: "auto",
                  justifyContent: "space-between",
                }}
              >
                <FormInput type="text" placeholder="Full Name" />
                <FormInput type="email" placeholder="Email" />
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  margin: "auto",
                  justifyContent: "space-between",
                }}
              >
                <FormInput type="tel" placeholder="Mobile Number" />
                <FormSelect value={value} onChange={handleChange}>
                  <option value={1} selected disabled>
                    Select
                  </option>
                  <option value={2}>type 1</option>
                  <option value={3}>type 2</option>
                  <option value={4}>type 3</option>
                  <option value={5}>type 4</option>
                </FormSelect>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  margin: "auto",
                  justifyContent: "space-between",
                }}
              >
                <FormInput
                  type="file"
                  multiple={true}
                  style={{ width: "100%", textIndent: "40%" }}
                />
              </div>
              <TrackButton type="submit" />
            </form>
          </div>
        </FormSection>
      </FormsContainer>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        {loading ? (
          <Spinner />
        ) : (
          <StatusCard
            onClick={() => handleClose}
            status="1532156"
            refNum={516532}
          />
        )}
      </Backdrop>
    </>
  );
};

export default Forms;
